import Vue from 'vue';
import VueI18n from 'vue-i18n';
//import store from '../store/index';

// store.dispatch('admin/i18n/getLocale');
// const locale = store.state.admin.i18n.locale;

// console.log('locale', locale);

//let languages = {};

//store.dispatch('admin/i18n/load', languages);

Vue.use(VueI18n);

export default new VueI18n({
  //locale
  //messages: languages
});
